export const environnement = {
  baseURL: "/eglise/v1",
};
